export const TWITTER_BASE_URL = "https://twitter.com/";
export const FACEBOOK_BASE_URL = "https://facebook.com/";

export const MONTHS = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre",
    "Décembre"
];

export const POST_FILTER = {
    all: 'all',
    favorites: 'favorites'
};

export const POST_CATEGORIES = {
    all: 'all',
    need: 'BESOIN',
    announcement: 'ANNONCE'
};

export const USER_POST_SELECTOR = {
    published: 'published',
    pinned: 'pinned'
};

export const USER_ITEM_TO_DISPLAY = {
    posts: 'posts',
    favoriteTags: 'favoriteTags'
};

export const HOME_ITEM_TO_DISPLAY = {
    posts: 'posts',
    tags: 'tags'
};

export const HOME_POST_PAGE_SIZE = 50;

export const DOMAIN = `${window.location.protocol}//${window.location.host}`;

export const ASSETS_FOLDER = `${DOMAIN}/assets`;

let apiBaseUrl;

if (DOMAIN.endsWith('almeki.io')){
    apiBaseUrl = 'https://resolveneed-api.herokuapp.com';
}
else if (DOMAIN.endsWith('almeki.tech')){
    apiBaseUrl = 'https://resolveneed-api-beta.herokuapp.com';
}
else {
    apiBaseUrl = 'http://localhost:8000';
}

export const API_BASE_URL = apiBaseUrl;

export const UPLOAD_FILES_ENDPOINT = `${API_BASE_URL}/rneed/utils/upload/`;
